import React, { Component } from 'react'
import YouTube from 'react-youtube'
import {
  CardWrapper,
  Title,
  Subtitle,
  Description,
  WrapperWrapper,
  VideoWrapper
} from './styles'

class Card extends Component {
  onReady = event => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo()
  }
  render() {
    const opts = {
      minWidth: '300',
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0
      }
    }
    return (
      <CardWrapper>
        <Title>{this.props.title}</Title>
        {this.props.subtitle && <Subtitle>{this.props.subtitle}</Subtitle>}
        {this.props.url && (
          <WrapperWrapper>
            <VideoWrapper>
              <YouTube
                videoId={this.props.url}
                opts={opts}
                onReady={this.onReady}
              />
            </VideoWrapper>
          </WrapperWrapper>
        )}
        {this.props.description && (
          <Description>{this.props.description}</Description>
        )}
      </CardWrapper>
    )
  }
}

export default Card



// WEBPACK FOOTER //
// ./src/containers/Music/components/MusicCarousel/components/Card/index.js